import CardReport from 'components/Cards/CardReport';
import HeaderStats from 'components/Headers/HeaderStats'
import React from 'react'
import { useSelector } from 'react-redux';


export default function Report() {
  const { user } = useSelector(state => state.user)
  if (user.role == 2) {
    window.location.href = "/order";
  }
  return (<>
    {user.role !== 2 &&
      <>
        <HeaderStats page={"Report"} />
        <div className="flex flex-wrap mt-4 ">
          <div className="w-full px-4 mb-12 ">
            <CardReport></CardReport>
          </div>
        </div>
      </>
    }
  </>
  )
}
